import * as React from 'react';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import { useNavigate, useLocation } from 'react-router-dom';

import {
    Container,
    FullWidthDrawer,
    StyledListItem,
    MenuButton,
    StyledMenuIcon,
    LogoContainer,
    CloseButtonWrapper,
    CloseButton,
    StyledCloseIcon,
    ActionsContainer
} from './styles';
import UserMenu from '../UserMenu';

const BurgerMenu: React.FC = () => {
    const [open, setOpen] = React.useState(false);
    const navigate = useNavigate();
    const location = useLocation();

    const toggleDrawer =
        (newOpen: boolean | ((prevState: boolean) => boolean)) => () => {
            setOpen(newOpen);
        };
    const handleShopClick = () => {
        if (location.pathname.startsWith("/shop")) {
            navigate("/shop");
            return;
        }

        window.open("/shop", "_blank", "noopener,noreferrer");
    };
    const handleNavigation = (text: string) => {
        switch (text) {
            case '\u00dcber uns':
                navigate("/ueber-uns");
                break;
            case 'Die Geschichte':
                navigate("/die-geschichte");
                break;
            case 'Die \u00c4ltesten':
                navigate("/die-aeltesten");
                break;
            case 'Hexenwerkstatt':
                navigate("/hexenwerkstatt");
                break;
            case 'Kontakt':
                navigate("/kontakt");
                break;
            case 'Shop':
                handleShopClick();
                break;
            default:
                break;
        }
    };

    const DrawerList = (
        <Box role="presentation" onClick={toggleDrawer(false)} sx={{ padding: '1.5rem' }}>
            <List>
                {['\u00dcber uns', 'Die Geschichte', 'Die \u00c4ltesten', 'Hexenwerkstatt', 'Kontakt', 'Shop'].map((text) => (
                    <StyledListItem key={text} disablePadding>
                        <ListItemButton onClick={() => handleNavigation(text)}>
                            <ListItemText
                                primary={text}
                                primaryTypographyProps={{ fontSize: '1.5rem' }}
                            />
                        </ListItemButton>
                    </StyledListItem>
                ))}
            </List>
        </Box>
    );

    return (
        <Container>
            <LogoContainer onClick={() => navigate("/")} />
            <ActionsContainer>
                <UserMenu compact />
                <MenuButton onClick={toggleDrawer(true)}>
                    <StyledMenuIcon />
                </MenuButton>
            </ActionsContainer>
            <FullWidthDrawer anchor="right" open={open} onClose={toggleDrawer(false)}>
                <CloseButtonWrapper>
                    <CloseButton onClick={toggleDrawer(false)}>
                        <StyledCloseIcon />
                    </CloseButton>
                </CloseButtonWrapper>
                {DrawerList}
            </FullWidthDrawer>
        </Container>
    );
};

export default BurgerMenu;
